import BaseService from "../base-service";
import NetworkUrls from "../network-urls";

class FaqService extends BaseService {

    async fetchCategories (options = {}) {
        options.lang = options.lang || 'fr';
        options.limit = options.limit || 20;
        options.page = options.page || 1;
        options['af[is_published_web]'] = 1;

        return this._exec({
            url: NetworkUrls.faqCategories,
            method: 'GET',
            params: options
        })
    }

    async search (search, lang, token) {
        const options = {
            blogArticles: 0,
            faqArticles: 1,
            faqKeywords: 1,
            faqCategories: 0,
            lang,
            token
        };
        return this._exec({
            url: NetworkUrls.faqSearch,
            method: 'POST',
            data: {
                search
            },
            params: options
        })
    }

    async fetchAuthBookings (accessToken) {
        const config = {
            url: NetworkUrls.graphql,
            method: 'POST',
            headers: {
                Authorization: accessToken,
            },
            data: {
                query: `query {
                    Auth {
                        incoming_bookings {
                            rooms: room_ids,
                            extras: extra_ids
                        }
                    }
                }`,
                variables: {}
            }
        }
        return this._exec(config)
    }

}

export const faqService = new FaqService();



// WEBPACK FOOTER //
// ./src/network/services/faq.service.js